import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Tooltip, Typography } from '@mui/material';

import theme from '../../theme';
import { isPdf } from '../../utils';

interface FilesOpenerProps {
  FilesUrls: string;
  onFileClick?: (url: string) => void;
}

const FilesOpener: React.FC<FilesOpenerProps> = ({ FilesUrls, onFileClick }) => {
  // Vérifier que FilesUrls est une chaîne valide
  if (!FilesUrls || typeof FilesUrls !== 'string' || FilesUrls.trim() === '') {
    return null;
  }

  return (
    <Typography variant="body2" component="div" textAlign={'center'} display={'flex'}>
      {FilesUrls.split(',').map((url: string, index: number) => {
        const trimmedUrl = url.trim();
        const decodedUrl = decodeURIComponent(trimmedUrl);
        const isImage =
          decodedUrl.includes('jpg') ||
          decodedUrl.includes('jpeg') ||
          decodedUrl.includes('png') ||
          decodedUrl.includes('gif');
        const isPdfFile = isPdf(trimmedUrl);

        const handleClick = (e: React.MouseEvent) => {
          if (onFileClick) {
            e.preventDefault();
            onFileClick(trimmedUrl);
          }
        };

        const openInNewTabButton = (
          <Tooltip title="Ouvrir dans un nouvel onglet" placement="top" arrow>
            <a
              href={trimmedUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              style={{
                position: 'absolute',
                top: 4,
                right: 4,
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.85)',
                color: '#333',
                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
                zIndex: 2,
                backdropFilter: 'blur(2px)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = theme.palette.saffron.main;
                e.currentTarget.style.transform = 'scale(1.15)';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.85)';
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.2)';
              }}
            >
              <OpenInNewIcon style={{ fontSize: 14 }} />
            </a>
          </Tooltip>
        );

        return (
          <div key={index} style={{ margin: '10px', textAlign: 'left', position: 'relative' }}>
            {openInNewTabButton}
            {isImage ? (
              <a
                href={onFileClick ? undefined : trimmedUrl}
                target={onFileClick ? undefined : '_blank'}
                rel="noopener noreferrer"
                onClick={handleClick}
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={trimmedUrl}
                  alt="thumbnail"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </a>
            ) : isPdfFile ? (
              <a
                href={onFileClick ? undefined : trimmedUrl}
                target={onFileClick ? undefined : '_blank'}
                rel="noopener noreferrer"
                onClick={handleClick}
                style={{
                  width: '100px',
                  height: '100px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'black',
                  background: theme.palette.saffron.main,
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
              >
                <PictureAsPdfIcon style={{ fontSize: '40px', color: 'black' }} />
                <span style={{ fontSize: '11px', fontWeight: '600', textAlign: 'center' }}>PDF {index + 1}</span>
              </a>
            ) : (
              <a
                href={onFileClick ? undefined : trimmedUrl}
                target={onFileClick ? undefined : '_blank'}
                rel="noopener noreferrer"
                onClick={handleClick}
                style={{
                  width: '100px',
                  height: '100px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'black',
                  background: theme.palette.saffron.main,
                  fontSize: '15px',
                  fontWeight: '600',
                  textAlign: 'center',
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
              >
                Fichier {index + 1}
              </a>
            )}
          </div>
        );
      })}
    </Typography>
  );
};

export default FilesOpener;
